import React, { PropsWithChildren }    from 'react';
import { DialogIntroductionContainer } from "@src/views/containers/DialogIntroductionContainer";
import { CorvalUIColor, Size }         from "@src/types";
import { Segment, SemanticICONS }      from "semantic-ui-react";


interface BulkUpdateFormControlContainerProps<T = never> extends PropsWithChildren<any> {
    icon: SemanticICONS,
    title: string,
    description?: string,
}

const BulkUpdateFormControlContainerDefaultProps = {} satisfies Partial<BulkUpdateFormControlContainerProps>

function BulkUpdateFormControlContainer<T>( { children, ...p }: BulkUpdateFormControlContainerProps<T> ){

    const props = { ...BulkUpdateFormControlContainerDefaultProps, ...p };

    return (
        <Segment color={ 'black' }>

            <DialogIntroductionContainer
                containerProps={ { padding: [ Size.SM, null ], bgColor: CorvalUIColor.WHITE, } }
                icon={ props.icon }
                title={ props.title }
                description={ props.description }
            />

            <Segment secondary>

                <Segment raised>

                    { children }

                </Segment>

            </Segment>

        </Segment>
    );
}

export {
    BulkUpdateFormControlContainer,
    BulkUpdateFormControlContainerDefaultProps,
    type BulkUpdateFormControlContainerProps,
};
